module.exports = __webpack_public_path__ + "media/images/officebooking-d3dadf23.png";